var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"try-info"},[_c('div',{staticClass:"top"}),_c('tryInfo',{attrs:{"type":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }